module.exports = __webpack_public_path__ + "static/media/rootsure.c164ed93.png";